import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AtxAffixDirective } from './directives';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        AtxAffixDirective,
    ],
    exports: [
        AtxAffixDirective,
    ],
})

export class AtxAffixModule {}
